import React from 'react';

const Footer = () => {
    return (
        <footer className='footer'>
            <div className='footer-content'>
                <p> © 2023 MEMS WORLD it's student project created by Anmakulaku</p>
                <p>All memes in this project are used for educational purposes</p>
            </div>
        </footer>
    );
};

export default Footer;